import { t } from 'i18next'

import * as yup from 'yup'

/**
 * Form constants
 */
const EMAIL = 'email'

/**
 * Form model
 */
const formModel = () => {
  return {
    [EMAIL]: {
      label: `${t('common.email')}`,
      name: EMAIL,
      required: true,
    },
  }
}

/**
 * Form initial data
 */
export const initialValues = {
  [EMAIL]: '',
}

/**
 * Form data validation
 */
export const validationSchema = () =>
  yup.object().shape({
    [EMAIL]: yup
      .string()
      .email(`${t('errors.email-error-message')}`)
      .required(`${t('errors.required-error-message')}`),
  })

export default formModel
